'use client';

import { c as _c } from "react/compiler-runtime";
import type { MarketId } from '@morpho-org/blue-sdk';
import { Button } from '@repo/ui';
import { Close } from '@repo/ui/icons';
import { RepayContent } from './components';
import { useRepayDialog } from './hooks/useRepayDialog';
export interface PositionManagerRepayDialogProps {
  marketId: MarketId;
  onClose: () => void;
}
function PositionManagerRepayDialog(t0) {
  const $ = _c(15);
  const {
    marketId,
    onClose
  } = t0;
  const {
    handleClose,
    isQueryLoading,
    queryError,
    loanAsset,
    collateralAsset,
    market
  } = useRepayDialog(marketId);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-title-sm">Repay</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Close />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== handleClose) {
    t3 = <div className="flex items-center justify-between gap-[16px]">{t1}<Button size="icon" onClick={handleClose} variant="secondary" aria-label="Close">{t2}</Button></div>;
    $[2] = handleClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = loanAsset ?? undefined;
  const t5 = collateralAsset ?? undefined;
  let t6;
  if ($[4] !== isQueryLoading || $[5] !== market || $[6] !== marketId || $[7] !== onClose || $[8] !== queryError || $[9] !== t4 || $[10] !== t5) {
    t6 = <RepayContent marketId={marketId} onClose={onClose} isQueryLoading={isQueryLoading} queryError={queryError} loanAsset={t4} collateralAsset={t5} market={market} />;
    $[4] = isQueryLoading;
    $[5] = market;
    $[6] = marketId;
    $[7] = onClose;
    $[8] = queryError;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <div className="gap-md flex flex-col" data-testid="repay-dialog">{t3}{t6}</div>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
export default PositionManagerRepayDialog;